"use client";

import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const Gauge = ({
  color,
  delay
}: {
  color: string;
  delay: string;
}) => <div data-section-id="103131" className="relative size-7 rounded-full border-2 border-muted-foreground/20 bg-background shadow-[inset_0_0_8px_rgba(0,0,0,0.8)] flex items-center justify-center overflow-hidden">
    {}
    <div className="absolute inset-0 rounded-full border-[1.5px] border-dashed border-muted-foreground/30 m-1" />
    {}
    <div className="absolute bottom-1/2 left-1/2 w-[1.5px] h-2.5 origin-bottom -translate-x-1/2 rounded-t-full" style={{
    backgroundColor: color,
    animation: `gauge-flutter 4s infinite ${delay}`,
    boxShadow: `0 0 6px ${color}`
  }} />
    {}
    <div className="absolute size-2 rounded-full bg-muted-foreground/80 z-10 shadow-sm border border-background" />
  </div>;
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-6">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <>
      {}
      <nav className="hidden md:flex items-center gap-8">
        {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground uppercase text-[14px] font-medium tracking-wider relative py-2 after:absolute after:bottom-0 after:left-1/2 after:h-[1px] after:w-0 after:-translate-x-1/2 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full hover:text-secondary transition-colors">
            {item.label}
          </Link>)}
      </nav>

      {}
      <button className="md:hidden p-2 text-foreground hover:text-secondary transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Přepnout menu">
        {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </button>

      {}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background/95 backdrop-blur-xl border-b border-border/50 flex flex-col py-4 px-6 gap-2 md:hidden shadow-2xl">
          {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} onClick={() => setIsMobileMenuOpen(false)} className="text-foreground uppercase text-[14px] font-medium tracking-wider py-3 border-b border-border/20 hover:text-secondary transition-colors flex items-center justify-between group">
              {item.label}
              <span className="w-0 h-[2px] bg-secondary transition-all duration-300 group-hover:w-8" />
            </Link>)}
        </div>}
    </>;
}
export default function NexoNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="header" className={`dark text-foreground sticky top-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-background/80 backdrop-blur-[12px] border-b border-border/30 shadow-lg" : "bg-background border-b border-transparent"}`}>
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes gauge-flutter {
            0% { transform: translateX(-50%) rotate(-30deg); }
            5% { transform: translateX(-50%) rotate(15deg); }
            10% { transform: translateX(-50%) rotate(-10deg); }
            15% { transform: translateX(-50%) rotate(25deg); }
            20% { transform: translateX(-50%) rotate(5deg); }
            25% { transform: translateX(-50%) rotate(40deg); }
            30% { transform: translateX(-50%) rotate(-5deg); }
            35% { transform: translateX(-50%) rotate(20deg); }
            40% { transform: translateX(-50%) rotate(-25deg); }
            45% { transform: translateX(-50%) rotate(10deg); }
            50% { transform: translateX(-50%) rotate(-30deg); }
            100% { transform: translateX(-50%) rotate(-30deg); }
          }
        `
    }} />

      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        {}
        <div className="flex items-center gap-5">
          <Link to="/HomePage" className="flex items-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/nexo_tech_logo_primary.png" alt="NEXO TECH" className="h-8 w-auto object-contain" />
          </Link>
          
          {}
          <div className="hidden sm:flex items-center gap-2.5 pl-2 border-l border-border/40">
            <Gauge color="hsl(200, 80%, 50%)" delay="0s" />
            <Gauge color="hsl(25, 80%, 50%)" delay="-1.2s" />
          </div>
        </div>

        {}
        <MenuProvider menu_id="46">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </section>;
}